import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BalconyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"balcony"}/>
}
